import axios from './index'


const origin = '/co/bus/';

const listBuses = () => {
    return new Promise(resolve => {
        axios.get(origin + 'ListBuses').then(res => resolve(res))
    })
}

const listAllBus = () => {
    return new Promise(resolve => {
        axios.get(origin + 'ListAllBus').then(res => resolve(res))
    })
}

const loadBusList = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/loadBusList', param).then(res => resolve(res));
    });
}
const lookBus = (id) => {
    return new Promise((resolve) => {
        axios.post(origin + '/lookBus', id).then(res => resolve(res));
    });
}
const addBus = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/addBus', param).then(res => resolve(res));
    }

    )
}

//
const updateBus = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/updateBus', param).then(res => resolve(res));
    })
}
const deleteBus = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/deleteBus', param).then(res => resolve(res));
    }

    )
}
const disableBus = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/DisableBus', param).then(res => resolve(res));
    }

    )
}
const enableBus = param => {
    return new Promise((resolve) => {
        axios.post(origin + '/enableBus', param).then(res => resolve(res));
    }

    )
}
const listAllBuses = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/ListAllBuses', param).then(res => resolve(res));
    });
}

const listBusesByTime = (param) => {
    return new Promise((resolve) => {
        axios.post(origin + '/ListBusesByTime', param).then(res => resolve(res));
    });
}


export default {
    listBuses,
    listAllBus,
    loadBusList,
    lookBus,
    enableBus,
    disableBus,
    deleteBus,
    addBus,
    updateBus,
    listAllBuses,
    listBusesByTime,

}